import React from "react";

function Refund() {
  return (
    <main>
      <section className="mb-50 mt-5">
        <div className="container">
          <div className="title-section">
            <h1 className="heading heading-decor fw-bold">Return and Refund-Policy</h1>
          </div>
          <h4 className="heading heading-decor">EXCHANGE & RETURN POLICY</h4>
          <p>
        <ul>
          <li>1. We accept exchanges and returns within 7 days of you receiving the shipment.</li>
          <li>2. If return location of the shipment is India, Aahilya Creations will pay the return shipping. We will arrange a return pickup from your location by our logistic partner. If, in any circumstances, we are not able to offer a pickup from your location, you can send us the parcel back by any reputed courier and we will reimburse return shipping charges.</li>
          <li>3. If return location of the shipment is outside India, Aahilya Creations will not be paying the return shipping charges. We can offer refund/replacements once products are received back into our warehouse. We strongly recommend you to choose carefully before making an international order as returns may be not very cost effective.</li>
           <li>4. Items must be marked as eligible for exchange and return on the product page</li>
        </ul>
          </p>


          <h4 className="heading heading-decor">EXCHANGE & RETURN PROCESS</h4>
          <p>
        <ul>
          <li>1. To raise a request, email at info@aahilya.com or Phone/ WhatsApp us at

+91-92893 70407</li>
          <li>2. We will initiate a reverse pickup from your shipping address within 48 hours</li>
          <li>3. Re-use the original packaging, including the cloth bag, for proper care and protection</li>
           <li>4. Items must be in their original condition, with their labels and tags intact</li>
           <li> 5. They must be unused and unwashed, unsoiled without any stains or damages</li>
           <li>6. Items returned, once verified at our facility, will be processed for an exchange or return</li>
           <li>7. Upon authorization of your return/refund request, we would be happy to offer you refund or replacement. You can get your money back into your originating bank account</li>
        
          <li>8. Typically, it takes 10-15 days to complete your exchange or return request</li>
        
        </ul>


          </p>

          <h4 className="heading heading-decor">MISSING OR DAMAGE POLICY</h4>
          <p>
        <ul>
          <li>1. A missing or damaged item claim must be raised within 2 days of receiving the parcel</li>
          <li>2. We will need photographs of the item(s) and the delivery parcel it was received in</li>
          <li>3. Our customer care team will investigate and offer an appropriate resolution</li>
        </ul>
          </p>

          <h4 className="heading heading-decor">CANCELLATION POLICY</h4>
          <p>
        <ul>
          <li>1. We accept cancellations against full refund within 12 hours of placing your order</li>
          <li>2. We are unable to accept any cancellation requests after 12 hours</li>
        </ul>
          </p>
    <p>Have a question? Chat with us, or e-mail us at <a href="mailto:info@aahilya.com" >info@aahilya.com</a> or call/WhatsApp us at <a href="+91-92893 70407" >+91-92893 70407</a>. We’d be happy to answer any question</p>

        </div>
      </section>
    </main>
  );
}

export default Refund;
